import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import OperationsFiltersDialog from "./OperationsFiltersDialog";
import { displayMultiSelect, displayObjectMultiSelect } from "../Utility/ChipDisplay";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";

interface IOperationsFiltersProps {
    isAgent: boolean
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function OperationsFilters({ isAgent, callTableViewModel, setCallTableViewModel }: IOperationsFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        < Typography variant="body1" >
            {
                'Operations'
            }
            {
                callTableViewModel.filters.operationsFilters.site.length > 0 ? ` - ${callTableViewModel.filters.operationsFilters.site}` : ''
            }
            {
                displayMultiSelect(callTableViewModel.filters.operationsFilters.channel, 'Channel')
            }
            {
                displayMultiSelect(callTableViewModel.filters.operationsFilters.team, 'Team')
            }
            {
                displayMultiSelect(callTableViewModel.filters.operationsFilters.teamLeader, 'Team Leader')
            }
            {
                displayObjectMultiSelect(callTableViewModel.filters.operationsFilters.agentName, 'name', 'Agent Name')
            }
        </Typography >

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable={!isAgent}
                onClick={() => setOpen(true)} />
            <OperationsFiltersDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}